module.exports = __webpack_public_path__ + "img/账户资金.d37c1386.svg";